import React from "react";
import {
  format,
  isValid,
  parseISO,
  differenceInMinutes,
  isToday,
  isTomorrow,
  isAfter,
  startOfDay,
} from "date-fns";
import SecondaryButton from "../../common/buttons/SecondaryButton";

import { IconDelete } from "../../../assets/icons/icon-delete";
import {
  convertUTCToLocal,
} from "../../common/constant/constant";
import { CallCalendarIcon } from "../../../assets/icons/call-icon-calendar";
import { useSelector, useDispatch } from "react-redux";
import { setTrialInfo } from "../../../reducer/slices/calendercount/calendar-slice";

const Agenda = ({
  cancelMeeting,
  isOpen,
  setIsOpen,
  meetId,
  setMeetId,
  handleCall,
}) => {
  const { allEvents } = useSelector(
    (state) => state.calendar,
  );
  const dispatch = useDispatch();
  const currentDate = new Date();
  const validDate = isValid(currentDate) ? currentDate : new Date();
  const isCallInProgress = useSelector((state) => state.call.callData);

  const setEventToCancel = (id) => {
    setIsOpen(true);
    setMeetId(id);
  };

  const closePopup = () => {
    setIsOpen(false);
  };

  const upcomingEvents = allEvents
    .map((event) => ({
      ...event,
      parsedStartTime: convertUTCToLocal(event.startTime).localDate,
      parsedEndTime: convertUTCToLocal(event.endTime).localDate,
    }))
    .filter(
      (event) =>
        isValid(event.parsedStartTime) &&
        isAfter(event.parsedStartTime, startOfDay(validDate)),
    )
    .sort((a, b) => a.parsedStartTime - b.parsedStartTime);

  let lastDisplayedDate = null;

  function isPastDateTime(startTime) {
    const currentDate = new Date();
    const inputDate = new Date(startTime);

    return inputDate < currentDate;
  }

  return (
    <div className="mt-4 bg-white shadow-md rounded-lg p-4 h-[calc(100vh-80px)] overflow-scroll relative z-30">
      <h2 className="agendaTitle text-lg font-bold">Agenda</h2>

      {upcomingEvents.length === 0 ? (
        <p className="text-gray-500 mt-4">No events scheduled</p>
      ) : (
        upcomingEvents.map((event, index) => {
          const eventDayLabel = isToday(event.parsedStartTime) ? (
            <span className="text-blue-600 font-semibold">Today</span>
          ) : isTomorrow(event.parsedStartTime) ? (
            <span className="font-semibold">Tomorrow</span>
          ) : (
            format(event.parsedStartTime, "EEEE")
          );

          const startTimeFormatted = format(event.parsedStartTime, "HH:mm");
          const duration = differenceInMinutes(
            event.parsedEndTime,
            event.parsedStartTime,
          );
          const formattedDate = format(event.parsedStartTime, "dd EEE");
          const eventClasses = event.isOpen ? "" : "line-through text-gray-500";
          const shouldDisplayDate = formattedDate !== lastDisplayedDate;
          lastDisplayedDate = formattedDate;
          return (
            <div key={index}>
              {shouldDisplayDate && (
                <h3
                  className={`mt-4 text-[16px] ${
                    isToday(event.parsedStartTime) && "blue_color font-semibold"
                  }`}
                >
                  {formattedDate} <span className="pipe-bar">|</span>{" "}
                  {eventDayLabel}
                </h3>
              )}
              <div className={`agendaWrapper text-left ${eventClasses}`}>
                <div className="flex">
                  <div className="pr-4 text-[14px] text_color w-1/4">
                    <p className="font-semibold title_color text-[14px] mb-[6px]">
                      {startTimeFormatted}
                    </p>
                    <p className="text-gray-500">{duration} min</p>
                  </div>
                  <div className="flex-1 text_color pl-4">
                    <p className="font-semibold title_color text-[14px] mb-[6px]">
                      {event.patientName} - {event.phoneNumber}
                    </p>
                    <p>{event.trialName}</p>
                    <p>
                      <span className="font-medium">Recruiter:</span>{" "}
                      {event.recruiterName}
                    </p>
                    {!isPastDateTime(event.parsedStartTime) && event.isOpen ? (
                      <button
                        onClick={() => setEventToCancel(event.calendarEventID)}
                        className="popupLink"
                      >
                        Cancel Meeting
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                  {!isPastDateTime(event.parsedStartTime) && event.isOpen ? (
                    <button
                      disabled={isCallInProgress}
                      className={isCallInProgress ? `cursor-not-allowed` : ``}
                      onClick={() => {
                        dispatch(setTrialInfo(event));
                        handleCall(event.phoneNumber);
                      }}
                    >
                      <CallCalendarIcon />
                    </button>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          );
        })
      )}

      {isOpen && (
        <div className="fixed w-full h-full inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 relative">
            <div>
              <div>
                <div className="flex flex-row mt-2 text-sm items-center">
                  <span className="delete-popup-bg item-center w-[50px!important]">
                    <IconDelete />
                  </span>
                  <span>Are you sure want to delete the meeting?</span>
                </div>
              </div>

              <div className="flex flex-row justify-end gap-5 mt-5">
                <button
                  className="px-5 py-1 text-base rounded-md border primary_btn transition-all duration-500 red_btn"
                  onClick={cancelMeeting}
                >
                  Yes
                </button>
                <SecondaryButton onClick={closePopup} label="Cancel" />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Agenda;
